import apiClient from './api';

/**
 * A single active OTP as returned by GET /admins/otps.
 * `code` is masked (e.g. "1••••6") unless the caller is a super admin,
 * in which case `codeIsMasked=false` and the full plaintext is exposed.
 */
export interface ActiveOTP {
  phone: string;
  code: string;
  codeIsMasked: boolean;
  expiresAt: string;         // ISO
  expiresInSeconds: number;  // Time remaining at the moment the row was fetched
  createdAt: string;         // ISO
}

export interface ActiveOTPsPagination {
  hasMore: boolean;
  lastEvaluatedKey?: string;
}

export interface ActiveOTPsResponse {
  items: ActiveOTP[];
  pagination: ActiveOTPsPagination;
}

/**
 * Admin OTPs service. Wraps GET /admins/otps.
 * apiClient's request interceptor auto-prefixes /admins, so we call /otps here.
 */
export const otpsService = {
  listActiveOTPs: async (params?: {
    limit?: number;
    lastEvaluatedKey?: string;
  }): Promise<ActiveOTPsResponse> => {
    const search = new URLSearchParams();
    if (params?.limit !== undefined) search.append('limit', String(params.limit));
    if (params?.lastEvaluatedKey) search.append('lastEvaluatedKey', params.lastEvaluatedKey);

    const suffix = search.toString() ? `?${search.toString()}` : '';
    const response = await apiClient.get<{ data: ActiveOTPsResponse }>(`/otps${suffix}`);

    // Handler wraps responses in { success, message, data, timestamp }.
    return response.data.data;
  },
};
